import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {

    console.log('Interceptor Hit');
    console.log('Token:', localStorage.getItem('access_token'));

    if (config.skipAuth) {
      return config;
    }

    if (config.customToken) {
      config.headers.Authorization = `Bearer ${config.customToken}`;
      return config;
    }

    const dynamicToken = localStorage.getItem('access_token');

    if (dynamicToken) {
      config.headers.Authorization = `Bearer ${dynamicToken}`;
    } 

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;